import carExtrasGroups from '../assets/json/car-extras';
import carExtrasTranslations from '../assets/translations/car-extras';
import carMakesTranslate from '../assets/translations/car-makes';
import { cities_eg } from '../assets/translations/cities_eg';

// Attributes Icons
const makeIcon = 'fa-solid fa-tag';
const modelIcon = 'fa-solid fa-car';
const registrationDateIcon = 'fa-regular fa-registered';
const mileageIcon = 'fa-solid fa-gauge';
const horsepowerIcon = 'fa-solid fa-bolt';
const conditionIcon = 'fa-solid fa-file-pen';
const exteriorColorIcon = 'fa-solid fa-fill-drip';
const interiorColorIcon = 'fa-solid fa-fill-drip';
const transmissionIcon = 'fa-solid fa-gear';
const engineIcon = 'fa-solid fa-car';
const drivetrainIcon = 'fa-solid fa-right-left';

function prepareAttributes(car) {
  let attributes = [];
  if (car) {
    attributes.push({
      id: 1,
      title: 'Make',
      specification: carMakesTranslate[car.make] ?? car.make,
      icon: makeIcon,
    });

    attributes.push({
      id: 2,
      title: 'Model',
      specification: car.model,
      icon: modelIcon,
    });

    attributes.push({
      id: 3,
      title: 'Year',
      specification: car.firstRegistration,
      icon: registrationDateIcon,
    });

    if (car.mileage) {
      attributes.push({
        id: 4,
        title: 'Mileage',
        specification: car.mileage.toLocaleString() + ' km',
        icon: mileageIcon,
      });
    }

    let fT = 'Benzin';
    if (car.fuelType !== null) {
      fT = car.fuelType?.charAt(0).toUpperCase() + car.fuelType.slice(1);

      if (fT === 'Petrol') {
        fT = 'Benzin';
      }
    }
   
    if (car.capacity) {
      attributes.push({
        id: 5,
        title: 'Capacity',
        specification: car.capacity + (fT === 'Benzin' ? 'cc' : ' kWh'),
        icon: horsepowerIcon,
      });
    }

    attributes.push({
      id: 6,
      title: 'Condition',
      specification: car.condition === 'usedCar' ? 'Used' : 'New',
      icon: conditionIcon,
    });

    if (car.totalOwners > 0) {
      attributes.push({
        id: 7,
        title: 'Total Owners',
        specification: car.totalOwners,
        icon: conditionIcon,
      });
    }

    attributes.push({
      id: 9,
      title: 'Transmission',
      specification: car.transmission
        ? car.transmission.charAt(0).toUpperCase() + car.transmission.slice(1)
        : '',
      icon: transmissionIcon,
    });

    attributes.push({
      id: 11,
      title: 'Description',
      specification: car.description ?? '',
      icon: engineIcon,
    });

    attributes.push({
      id: 12,
      title: 'Location',
      specification: cities_eg[car.city] ?? car.city,
      icon: engineIcon,
    });

    //console.log('car.fuelType', car.fuelType);

    attributes.push({
      id: 10,
      title: 'Fuel',
      specification: fT,
      icon: engineIcon,
    });

  }
  return attributes;
}

function prepareExtras(car) {
  const groupedExtras = groupExtras(car.extras);
  // safetyExtras
  const safetyExtras = groupedExtras.find(
    (group) => group.category === 'carExtraGroupSafetySecurity'
  )?.extras;
  let mappedSafetyExtras = safetyExtras?.map(function (extra, ind) {
    return { id: ind, item: extra };
  });
  // carExtraGroupLightingVisibility
  const lightingExtras = groupedExtras.find(
    (group) => group.category === 'carExtraGroupLightingVisibility'
  )?.extras;
  let mappedLightingExtras = lightingExtras?.map(function (extra, ind) {
    return { id: ind, item: extra };
  });
  // carExtraGroupExteriorWheels
  const exteriorWheelsExtras = groupedExtras.find(
    (group) => group.category === 'carExtraGroupExteriorWheels'
  )?.extras;
  let mappedExteriorWheelsExtras = exteriorWheelsExtras?.map(
    function (extra, ind) {
      return { id: ind, item: extra };
    }
  );
  // carExtraGroupInfotainment
  const infotainmentExtras = groupedExtras.find(
    (group) => group.category === 'carExtraGroupInfotainment'
  )?.extras;
  let mappedInfotainmentExtras = infotainmentExtras?.map(function (extra, ind) {
    return { id: ind, item: extra };
  });
  // carExtraGroupComfortInterior
  const comfortInteriorExtras = groupedExtras.find(
    (group) => group.category === 'carExtraGroupComfortInterior'
  )?.extras;
  let mappedComfortInteriorExtras = comfortInteriorExtras?.map(
    function (extra, ind) {
      return { id: ind, item: extra };
    }
  );
  // carExtraGroupEmergencyUtility
  const emergencyUtilityExtras = groupedExtras.find(
    (group) => group.category === 'carExtraGroupEmergencyUtility'
  )?.extras;
  let mappedEmergencyUtilityExtras = emergencyUtilityExtras?.map(
    function (extra, ind) {
      return { id: ind, item: extra };
    }
  );
  // carExtraGroupPerformance
  const performanceExtras = groupedExtras.find(
    (group) => group.category === 'carExtraGroupPerformance'
  )?.extras;
  let mappedPerformanceExtras = performanceExtras?.map(function (extra, ind) {
    return { id: ind, item: extra };
  });
  // carExtraGroupParking
  const parkingExtras = groupedExtras.find(
    (group) => group.category === 'carExtraGroupParking'
  )?.extras;
  let mappedParkingExtras = parkingExtras?.map(function (extra, ind) {
    return { id: ind, item: extra };
  });
  return {
    groupedExtras,
    mappedSafetyExtras,
    mappedLightingExtras,
    mappedExteriorWheelsExtras,
    mappedInfotainmentExtras,
    mappedComfortInteriorExtras,
    mappedEmergencyUtilityExtras,
    mappedPerformanceExtras,
    mappedParkingExtras,
  };
}

function groupExtras(array, mapping = carExtrasGroups) {
  const grouped = {};
  // Return empty array if no extras
  if (!array || !Array.isArray(array)) {
    return [];
  }

  Object.values(mapping).forEach(({ name, category }) => {
    if (array.includes(name)) {
      if (!grouped[category]) {
        grouped[category] = new Set();
      }
      grouped[category].add(carExtrasTranslations[name] ?? name);
    }
  });

  return Object.entries(grouped).map(([category, extras]) => ({
    category,
    extras: Array.from(extras),
  }));
}

function padImageToAspectRatio(
  imageUrl,
  targetWidth = 803,
  targetHeight = 493
) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = 'anonymous'; // Allows handling images from different origins (optional)
    img.src = imageUrl;

    img.onload = async function () {
      //console.log("Image loaded:", img.width, img.height);

      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      // Set canvas to target dimensions
      canvas.width = targetWidth;
      canvas.height = targetHeight;

      // Fill the canvas with black (background)
      ctx.fillStyle = 'black';
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      // Calculate aspect ratio of the original image
      const imgAspectRatio = img.width / img.height;
      const targetAspectRatio = targetWidth / targetHeight;

      let drawWidth, drawHeight, offsetX, offsetY;

      if (imgAspectRatio > targetAspectRatio) {
        // Image is wider than target, fit width and adjust height
        drawWidth = targetWidth;
        drawHeight = targetWidth / imgAspectRatio;
        offsetX = 0;
        offsetY = (targetHeight - drawHeight) / 2; // Center vertically
      } else {
        // Image is taller than target, fit height and adjust width
        drawHeight = targetHeight;
        drawWidth = targetHeight * imgAspectRatio;
        offsetX = (targetWidth - drawWidth) / 2; // Center horizontally
        offsetY = 0;
      }

      // Draw the scaled image onto the canvas
      ctx.drawImage(img, offsetX, offsetY, drawWidth, drawHeight);

      const blob = await getCanvasBlob(canvas);
      window.URL = window.URL || window.webkitURL;
      const paddedImageUrl = window.URL.createObjectURL(blob);
      resolve(paddedImageUrl);
    };

    //console.log("Trying to load image from:", imageUrl);

    img.onerror = function () {
      reject(new Error('Failed to load image.'));
    };
  });
}

function getCanvasBlob(canvas) {
  return new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => {
        resolve(blob);
      },
      'image/png',
      0.5
    );
  });
}

export { prepareAttributes, prepareExtras, padImageToAspectRatio };
